var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    r: 30,
    fill: "#FFDB3A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49,
    y1: 3,
    x2: 85,
    y2: 3,
    stroke: "#FFDB3A",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.0824,
    y1: 27.6942,
    x2: 87.342,
    y2: 13.9176,
    stroke: "#FFDB3A",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 50.4559,
    x2: 94.4558,
    y2: 25,
    stroke: "#FFDB3A",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.9176,
    y1: 67.3421,
    x2: 104.694,
    y2: 34.0824,
    stroke: "#FFDB3A",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: 73,
    x2: 116,
    y2: 37,
    stroke: "#FFDB3A",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 119.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 4 119.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: 77.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 -38 77.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 99.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 24 99.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: 57.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 -18 57.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 121.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 86 121.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 79.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 44 79.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 37.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 2 37.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 37.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 2 37.5)",
    fill: "#1968C1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -4.5,
    width: 24.7487,
    height: 54.1533,
    transform: "rotate(-45 -40 -4.5)",
    fill: "#1968C1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    stroke: "#1968C1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.92495fb9358b2cc52b7fee4e06aeabc6.svg";
export { ForwardRef as ReactComponent };